import React, { Component } from 'react'
import { browserHistory, Router } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import routes from './routes'
import configureStore from './store/configure-store'

const initialState = window.__INITIAL_STATE__ // eslint-disable-line no-underscore-dangle
const store = configureStore(initialState)
const history = syncHistoryWithStore(browserHistory, store)

export default class App extends Component {

  render() {
    return (
      <Router history={history} routes={routes} />
    )
  }

}



// WEBPACK FOOTER //
// ./src/app.js